import React from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import CandidateLayout from "../layouts/CandidateLayout";
import CandidateProtectedRoute from '../components/CandidateProtectedRoute';

import PublicLayout from '../layouts/PublicLayout';
import Login from "../pages/candidate/Auth/Login";


import Dashboard from "../pages/candidate/Dashboard/Dashboard";
import Jobs from "../pages/candidate/Jobs/Jobs";
import SavedJobs from "../pages/candidate/Jobs/SavedJobs";
import CandidateJobDetail from "../pages/candidate/Jobs/CandidateJobDetail";

import EmployerProfile from "../pages/candidate/Employer/EmployerProfile";
import Applications from "../pages/candidate/Applications/Applications";
import Profile from "../pages/candidate/Profile/Profile";
import Interviews from '../pages/candidate/Interviews/Interviews';
import AIAssistant from '../pages/candidate/AI-Tools/AIAssistant';
import CareerGuide from '../pages/candidate/AI-Tools/CareerGuide';
import SkillAnalysis from '../pages/candidate/AI-Tools/SkillAnalysis';
import Settings from '../pages/candidate/Account/Settings';
import ChangePassword from '../pages/candidate/Account/ChangePassword';

const CandidateRoutes = () => {
  return (
    <Routes>
      {/* <Route path="/" element={<CandidateLayout />}> */}

      {/* Login Auth Routes (without layout) */}
      <Route path="/" element={<PublicLayout />}>
        <Route path="/login" element={<Login />} />
      </Route>
      
      {/* Protected Candidate Routes (with layout) */}
      <Route path="/" element={
        <CandidateProtectedRoute>
          <CandidateLayout />
        </CandidateProtectedRoute>
      }>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />

        <Route path="jobs" element={<Jobs />} />
        <Route path="saved-jobs" element={<SavedJobs />} />
        <Route path="jobs/:id" element={<CandidateJobDetail />} />

        <Route path="employer/:id" element={<EmployerProfile />} />
        <Route path="applications" element={<Applications />} />
        <Route path="profile" element={<Profile />} />
        <Route path="interviews" element={<Interviews />} />

        {/* AI tools */}
        <Route path="ai-assistant" element={<AIAssistant />} />
        <Route path="career-guide" element={<CareerGuide />} />
        <Route path="skill-analysis" element={<SkillAnalysis />} />

        {/* Account */}
        <Route path="settings" element={<Settings />} />
        <Route path="change-password" element={<ChangePassword />} />
      </Route>
    </Routes>
  );
};

export default CandidateRoutes;